<h2 mat-dialog-title>Grant Access to Roles</h2>
<mat-dialog-content>
  <mat-selection-list color="primary" (selectionChange)="change($event)" aria-label="Available roles">
    <div matSubheader class="role-option">
      <span>Role</span>
      <span>Select</span>
    </div>
    @for (role of availableRoles; track role; let i = $index)
    {
      <mat-list-option [selected]="roleSelected(role)" [value]="role">
        <div class="role-option">
          <mat-icon>shield</mat-icon>
          <span>{{role.name}}</span>
        </div>
      </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content> 
<mat-dialog-actions align="end">
  <button mat-flat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary"  (click)="onGrantAccess()" cdkFocusInitial>Grant Access</button>
</mat-dialog-actions>